import { render, staticRenderFns } from "./ShippingIntegrationList.vue?vue&type=template&id=722d4357"
import script from "./ShippingIntegrationList.vue?vue&type=script&lang=js"
export * from "./ShippingIntegrationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports